import { http } from '../../../../api/http';
import type { LibroRemuneracionesData, TRegistroData } from '../types/reportes';

const ENDPOINT = '/planilla/reportes';

export class ReportesService {
  static async getLibroRemuneraciones(idPlanilla: number): Promise<LibroRemuneracionesData> {
    const response = await http.get(`${ENDPOINT}/libro-remuneraciones/${idPlanilla}`);
    return response.data;
  }

  static async exportLibroRemuneracionesCsv(idPlanilla: number): Promise<void> {
    const response = await http.get(`${ENDPOINT}/libro-remuneraciones/${idPlanilla}/csv`, {
      responseType: 'blob',
    });
    downloadBlob(response.data, `LibroRemuneraciones_${idPlanilla}.csv`);
  }

  static async getTRegistro(): Promise<TRegistroData> {
    const response = await http.get(`${ENDPOINT}/t-registro`);
    return response.data;
  }

  static async exportTRegistroCsv(): Promise<void> {
    const response = await http.get(`${ENDPOINT}/t-registro/csv`, {
      responseType: 'blob',
    });
    downloadBlob(response.data, 'TRegistro.csv');
  }
}

function downloadBlob(data: Blob, filename: string) {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}
